__webpack_require__.p = "/packs/medical-licence/";